import { helper } from '@ember/component/helper';

import { formatDate } from 'rise-ui/utils/date.js';

export default helper(function dateHelper([ date, format ]) {
  return date instanceof Date ? formatDate(date, format) : '';
});
